import React from 'react'

export default function Tutorial() {
    return (
        <div>
            <h2>Tutorial</h2>

            <div>
            {/* To Access, stake 1 LDF. */}

            <div>Coming Soon ...</div>
                </div>
        </div>
    )
}
